<template>
  <div class="search-results row p-3" v-if="results.length">
    <table class="table col-12">
      <tbody class="list">
        <tr v-for="item in results" :key="item.id">
          <td v-for="(attribute, index) in attributes" :key="index">
            <router-link
              :to="{ path: composeEditLink(item) }"
              class="link"
              v-if="attribute === 'name'"
            >
              {{ item[attribute] | uppercase }}
            </router-link>
            <div v-if="attribute === 'code'">
              {{ item.code }}
            </div>
            <div
              class="delete-ledger"
              v-if="attribute === 'id'"
              @click="deleteLedger(item.id)"
            >
              <icons-delete></icons-delete>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    results: {
      type: Array,
      required: true
    },
    attributes: {
      type: Array,
      required: false
    }
  },
  methods: {
    deleteLedger (id) {
      this.$emit('delete', id)
    },
    composeEditLink (item) {
      return '/settings/ledger/' + item.id
    }
  }
}
</script>
<style>
.link {
  color: #0099e5 !important;
}
.delete-ledger {
  width: 24px;
  height: auto;
  cursor: pointer;
  margin: 0 auto;
}
.delete-ledger svg {
  fill: #0099e5;
}
table td {
  vertical-align: middle !important;
}
p {
  margin: 0;
}
table td:first-child {
  width: 20%;
}

table td:nth-child(2) {
  width: 70%;
}

table td:last-child {
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/ledger/list/ListItem.vue